type HiddenAsiInputProps = {
    id: string;
    value: string;
    name: string;
};

export const HiddenValueInput = (props: HiddenAsiInputProps) => {
    const { id, value, name } = props;

    return id ? (
        <div>
            <input value={value || ""} type="hidden" id={id} name={name} />
        </div>
    ) : null;
};